import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId8: SiteIdOverrideConfig = {
  car: {
    driveAgeCheckbox: true,
  },
};
